module.exports = __webpack_public_path__ + "static/media/work-experience.e80d252b.svg";